<footer class="footer-area footer-area-v4">
    <div class="footer-container">
        <div class="footer-area-internal container">
            <div class="row">
                <!-- Single Footer Widget -->
                <div class="col-lg-5 col-md-6 wow fadeInUp text-muted" data-wow-delay="0.1s">
                    <div class="single-footer-widget">
                        <p class="widget-title">About ThreatLabz</p>
                        <p class="footer-widget-menu" style=" line-height: 32px; color: white;">
                            ThreatLabz is the embedded research team at Zscaler. This global team includes security
                            experts, researchers, and network engineers responsible for analyzing and eliminating threats
                            across the Zscaler security cloud and investigating the global threat landscape. The team
                            shares its research and cloud data with the industry at large to help promote a safer
                            internet.
                        </p>
                    </div>
                    <!-- <p style="color: white; position: relative; bottom: 0;">&copy; 2008 {{footerDate}} <a href="https://www.zscaler.com/"
                            target="_blank"> Zscaler Inc</a> . All rights reserved.</p> -->

                </div>

                <!-- Single Footer Widget -->
                <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s"
                    *ngFor="let data of links | slice:0:1">
                    <div class="single-footer-widget">
                        <p class="widget-title">{{data.title}}</p>
                        <div class="footer-widget-menu">
                            <ul>
                                <li *ngFor="let item of data.items"><a href="{{location}}{{item.link}}">{{item.title}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- Single Footer Widget -->
                <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s" *ngFor="let data of links2">
                    <div class="single-footer-widget">
                        <p class="widget-title">{{data.title}}</p>
                        <div class="footer-widget-menu">
                            <ul>
                                <li *ngFor="let item of data.items">
                                    <ng-container *ngIf="!item.extraLink">
                                        <a href="{{location}}{{item.link}}">
                                            <!-- <img *ngIf="item.image" class="imageHide" [src]="item.imagelink"
                                            alt="blog thumbnail one"> -->
                                            {{item.title}}
                                        </a>
                                    </ng-container>
                                    <ng-container *ngIf="item.extraLink">
                                        <a [href]="item.link" target="_blank">
                                            <!-- <img *ngIf="item.image" class="imageHide" [src]="item.imagelink"
                                            alt="blog thumbnail one"> -->
                                            {{item.title}}
                                        </a>
                                    </ng-container>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="footer-social-links mb-2">
                        <ul>
                            <li><a href="https://www.facebook.com/Zscaler" title="Visit us on Facebook"
                                    target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                            <!-- <li><a href="https://twitter.com/zscaler" title="Follow us on Twitter" target="_blank"><i
                                        class="fab fa-twitter"></i></a></li> -->
                            <li><a href="https://twitter.com/Threatlabz" title="Follow us on Twitter" target="_blank"><i
                                class="fab fa-x-twitter"></i></a></li>
                            <li><a href="https://www.youtube.com/user/ZscalerMarketing"
                                    title="Subscribe our Youtube Channel" target="_blank"><i
                                        class="fab fa-youtube"></i></a></li>
                            <li><a href="https://www.linkedin.com/company/zscaler/" title="Find us on LinkedIn"
                                    target="_blank"><i class="fab fa-linkedin"></i></a></li>
                            <li><a href="https://github.com/threatlabz" title="Find us on LinkedIn"
                                target="_blank"><i class="fab fa-github"></i></a></li>
                        </ul>
                    </div>
                </div>
                <!-- Single Footer Widget -->
                <!-- <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
                    <div class="single-footer-widget gallery-widget">
                        <h5 class="widget-title">Gallery</h5>
                        <ul class="gallery-list">
                         
                        </ul>
                    </div>
                </div> -->
            </div> <!-- /.row -->
            <p style="color: white;">&copy; Zscaler Inc, 2008{{footerDate}} <a href="https://www.zscaler.com/" target="_blank">
                    </a>. All rights reserved.</p>
        </div><!-- /.footer-area-internal -->
    </div> <!-- /.container -->

    <div class="footer-copyright-area wow fadeInDown" data-wow-delay="0.8s">
        <div class="container">
            <div class="row align-items-center">
                <!-- <div class="col-12">
                    <div class="text-center">
                        <p>&copy; 2008 {{footerDate}} <a href="https://www.zscaler.com/" target="_blank" class="text-primary">Zscaler Inc</a> . All rights reserved.</p>
                    </div>
                </div> -->
            </div> <!-- /.row -->
        </div> <!-- /.container -->
    </div> <!-- /.footer-copyright-area -->
</footer>